import AutoSuggest from './auto-suggest';

export default AutoSuggest;